import React, { useMemo } from "react";
import { Modal } from "react-bootstrap";
import SLMVolumeFoliosList from "containers/slm/shared/SLMVolumeFoliosList";
import { createElementIdFactory, createSLMVolumeFoliosModalElementIds } from "utils/elementIds";

export default function SLMVolumeFoliosModal({
  show,
  onClose,
  user,
  updateTableState,
  filter,
  saveForm,
  data,
  saveRecord,
  deleteRecord,
  isAuthenticated,
  validateRelatedRecord,
  dataFetch,
  streetOptions,
  context,
  ctx,
}) {
  const createId = useMemo(() => createElementIdFactory("slm-volume-folios-modal"), []);
  const elementIds = useMemo(() => createSLMVolumeFoliosModalElementIds(createId), [createId]);

  return (
    <Modal show={show} onHide={onClose} dialogClassName="slm-title-details-modal-wide" size="xl" id={elementIds.modal}>
      <Modal.Header closeButton>
        <Modal.Title id={elementIds.title}>Volume Folio Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-2 px-md-3" style={{ overflowX: "auto" }}>
        <SLMVolumeFoliosList
          filter={filter}
          isAuthenticated={isAuthenticated}
          isLoading={false}
          controlType="table"
          saveForm={saveForm}
          user={user}
          data={data}
          dataFetch={dataFetch}
          updateTableState={updateTableState}
          saveRecord={saveRecord}
          deleteRecord={deleteRecord}
          validateRelatedRecord={validateRelatedRecord}
          streetOptions={streetOptions}
          context={context}
          ctx={ctx}
        />
      </Modal.Body>
    </Modal>
  );
}
